import { Grid } from '@material-ui/core'
import React, { useState } from 'react'

import BuyButton from '../buy/dumb/BuyButton'
import BuyTextInput2 from '../buy/dumb/BuyTextInput'
import CouponConfig from '../common/CouponConfig'
import CouponTick from '../icons/CouponTick'

function createCoupon({ value }) {
  return {
    type: value ? 1 : null,
    editing: !value,
    value,
  }
}

export default ({
  starterCoupon,
  maxCoupons,
  onCouponSubmitted,
  selloutSettings,
}) => {
  const [coupons, setCoupons] = useState([
    createCoupon({ value: starterCoupon }),
  ])

  const canAddMoreCoupons =
    coupons.length < maxCoupons && !coupons[coupons.length - 1].editing

  return (
    <>
      {coupons.map((coupon, i) => (
        <Grid
          container
          key={`coupons_${i}`}
          spacing={0}
          style={{ marginBottom: '13px' }}
          xs={12}
        >
          <Grid container justify="space-between" spacing={0}>
            <Grid item spacing={0} xs={12}>
              <div
                className={'data-form coupon-form'}
                style={{ marginTop: '0px', marginBottom: '5px' }}
              >
                <div
                  className={`wide ${
                    coupon.error ? 'is-error' : null
                  } no-after`}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ width: '61%' }}>
                    <BuyTextInput2
                      classes={'input-data form-input big capitalize'}
                      defaultValue={coupon.value || ''}
                      disabled={!coupon.editing}
                      label={''}
                      name={'name'}
                      onInput={e => {
                        const { value } = e.target
                        coupon.value = value
                        coupon.error = false

                        setCoupons(coupons.slice())
                      }}
                      placeholder={'Inserisci codice'}
                      type={'text'}
                      update={() => {
                        if (
                          (!coupon.value || !coupon.value.length) &&
                          coupons.length > 1
                        ) {
                          setCoupons(coupons.slice(0, -1))
                        }
                      }}
                    />
                  </div>
                  <div style={{ width: '37%' }}>
                    <BuyButton
                      classes={`btn btn-secondary inverted ${
                        coupon.value ? 'typing ' : ' '
                      }${
                        !coupon.editing || !coupon.value ? 'btn-disabled ' : ' '
                      }`}
                      disabled={
                        !coupon.editing ? !coupon.editing : !coupon.value
                      }
                      isBlock
                      label={
                        !coupon.editing && !coupon.error ? (
                          <CouponTick />
                        ) : (
                          'Applica'
                        )
                      }
                      update={async () => {
                        if (
                          coupons.length > 0 &&
                          !coupons.filter(coupon => coupon.editing).length
                        ) {
                          coupon.error =
                            'Il codice non è valido, hai già applicato un codice per questa promozione'

                          return
                        }

                        const submittedResult = await onCouponSubmitted(coupon)
                        if (typeof submittedResult === 'object') {
                          // in caso di validazione advanced lato backend
                          coupon.error = submittedResult.message
                        } else {
                          // caso standard true/false
                          if (!submittedResult) {
                            coupon.error = 'Il codice non è valido, riprova'
                          }
                          if (!coupon.error) {
                            coupon.editing = false
                          }
                        }

                        setCoupons(coupons.slice())
                      }}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          {coupon.error ? (
            <Grid
              container
              justify="start"
              md={12}
              sm={7}
              style={{ color: '#9B1100' }}
              xs={9}
            >
              <Grid item>
                <span>{coupon.error}</span>
              </Grid>
            </Grid>
          ) : null}
          {!coupon.editing && !coupon.error ? (
            <React.Fragment>
              <Grid
                container
                justify="space-between"
                md={12}
                sm={7}
                style={{ color: '#287D3C' }}
                xs={9}
              >
                <Grid item>
                  <span>Il codice è stato applicato.</span>
                </Grid>
                <Grid item>
                  <a
                    onClick={() => {
                      coupon.editing = true
                      setCoupons(coupons.slice())
                    }}
                    style={{
                      textDecoration: 'underline',
                      color: '#212121',
                      fontWeight: 'bold',
                    }}
                  >
                    Modifica
                  </a>
                </Grid>
              </Grid>
              <CouponConfig
                couponCode={coupon.value}
                selloutSettings={selloutSettings}
              />
            </React.Fragment>
          ) : null}
        </Grid>
      ))}
      {canAddMoreCoupons ? (
        <Grid className="text-center" item xs={12}>
          <div className="space-20"></div>
          <a
            className="help-link"
            onClick={() => setCoupons([...coupons, createCoupon({})])}
            style={{ fontSize: '14px' }}
          >
            Aggiungi un altro codice
          </a>
        </Grid>
      ) : null}
    </>
  )
}
